import React from 'react'
import { Route, Link } from 'react-router-dom'
import classNames from 'classnames'

const NavLink = ({ children, to, ...rest }) =>
  /:\/\//.test(to) ? (
    <a href={to} {...rest}>
      {children}
    </a>
  ) : (
    <Link to={to} {...rest}>
      {children}
    </Link>
  )

export default ({
  children,
  passed,
  to,
  exact,
  className,
  linkClassName,
  activeClassName,
  ...rest
}) => (
  <Route
    path={to}
    exact={exact}
    children={({ match }) => (
      <li
        className={classNames(
          match && (activeClassName || 'active'),
          { passed: passed && !match },
          className
        )}
      >
        <NavLink to={to} className={classNames(linkClassName)} {...rest}>
          {children}
        </NavLink>
      </li>
    )}
  />
)



// WEBPACK FOOTER //
// ./src/containers/layouts/default/nav/item.js